import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useGetNewSession } from 'src/app/shared/hooks/session';
import type { SuccessfulLoginOrJoinTrackingParams } from 'src/app/shared/utils/loginOrJoin';
import { getSuccessfulLoginOrJoinTrackingProps } from 'src/app/shared/utils/loginOrJoin';

type UseTrackSuccessfulLoginOrJoinParams = {
	trackSuccessfulLoginOrJoin: (params: SuccessfulLoginOrJoinTrackingParams) => Promise<void>;
};

export function useTrackSuccessfulLoginOrJoin(): UseTrackSuccessfulLoginOrJoinParams {
	const { facebook } = useUtilityContext();
	const track = useTracking();
	const getNewSession = useGetNewSession();

	const trackSuccessfulLoginOrJoin = async (params: SuccessfulLoginOrJoinTrackingParams): Promise<void> => {
		const { newUser, userId } = params;
		let currentUserId;
		// Only query a fresh session if we need updated user data
		if (userId) {
			currentUserId = userId;
		} else {
			try {
				const updatedSession = await getNewSession();
				currentUserId = updatedSession.user?.id;
			} catch (e) {
				// do nothing
			}
		}
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const { user_id, ...trackingParams } = getSuccessfulLoginOrJoinTrackingProps({
			...params,
			facebook,
			userId: currentUserId,
		});
		if (newUser) {
			void track('signup', trackingParams, { defaultOverrides: { user_id } });
		}
		void track('successful_login_or_join', trackingParams, { defaultOverrides: { user_id } });
	};
	return {
		trackSuccessfulLoginOrJoin,
	};
}
